import React from "react";
import { GlobalProvider } from "./Global";

export default function ContextProviders({ children }) {
  return <GlobalProvider>{children}</GlobalProvider>;
}
